import type { FC } from 'react';

import type { HiddenProps } from './types/hidden.props';

/**
 * A component that displays a message indicating the number of hidden items.
 *
 * @param count - The number of hidden items to display.
 * @returns A div element showing the count of hidden items in the format "+{count} more".
 */
const Hidden: FC<HiddenProps> = ({ count }) => {
  return <div className="hsp-select-hidden">{`+${count} more`}</div>;
};

export default Hidden;
